
























































































































































































































import validators from '@/validators';
import {ENDPOINTS, get, post, put} from '@/api/mainApi';
import Vue from 'vue';
import {RequestSession} from "@/interfaces/requestSession";
import donationSteps from "@/donationSteps";
import {DonationCertificate} from "@/interfaces/donation/certificate/donationCertificate";
import DonationCaseSummaryComponent from "@/components/summary/DonationCaseSummaryComponent.vue";
import DonorSummaryComponent from "@/components/summary/DonorSummaryComponent.vue";
import PaylinkErrorRetryComponent from "@/components/payment/PaylinkErrorRetryComponent.vue";
import DonationSummaryComponent from "@/components/summary/DonationSummaryComponent.vue";
import {Donation} from "@/interfaces/donation/donation";
import {isInvoice, isPayLink, isDigitalPayment} from "@/classes/PaymentMethod";
import {Sms} from "@/interfaces/sms";
import {Snackbar} from "@/interfaces/presentation/snackbar";
import {SmsType} from "@/enums/smsType";
import {AttributeType} from "@/enums/attributeType";
import {trackEvent} from "@/utils/pageSense";
import { isMemoryGift } from '@/classes/DonationType';

export default Vue.extend({
  components: {
    DonationCaseSummaryComponent,
    DonorSummaryComponent,
    DonationSummaryComponent,
    PaylinkErrorRetryComponent
  },
  props: {
    intentText: {
      type: String,
      default: 'confirm.form.acceptReasonMemorial.label',
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      valid: false,
      preview: false,
      acceptPreview: false,
      acceptReason: true,
      paymentMethod: null,
      certificateSrc: '',
      previewError: false,
      submitError: false,
      submitting: false,
      snackbar: false,
      loadingPreview: true,
      showSummary: false,
      loadingSendingSms: false,
      sms : {
        errorDialog: false,
        errorMessage: '',
        smsValidationWaitTime: 4000
      },
      rules: validators(this.$t('validation')),
      payText: '',
    }
  },
  computed: {
    requestSession(): RequestSession {
      return this.$store.state.requestSession as RequestSession
    },
    donation(): Donation {
      return this.$store.state.donation as Donation
    },
    currentStep() {
      return this.$store.state.currentStep
    },
    isMemoryGift() {
      return (this as any).donation && isMemoryGift(this.donation.donationType.type)
    },
    subtitleText() {
      if (this.isInvoicePayment()) {
        return this.$t('confirm.textInvoice')
      }
      else {
        return this.$t('confirm.textStandard');
      }
    },
    hasAdminPercentage(): boolean {
      return !!this.donation.paymentSpecification && !!this.donation.paymentSpecification.adminPercentage;
    },
  },
  watch: {
    currentStep(val) {
      this.showSummary = false;
      if (val == donationSteps.step.SUMMARY) {
        if (this.isMemoryGift) {
          this.loadingPreview = true;

          let certificateData: DonationCertificate = {
            imageId: this.donation.donationImageId,
            deceasedName: this.getAttributeValueById(AttributeType.SUBJECT_NAME),
            donationCauseId: this.donation.donationCause.id,
            message: this.getAttributeValueById(AttributeType.GREETING),
            donorNames: this.getAttributeValueById(AttributeType.DONOR_NAME),
            source : ""
          };

          post(ENDPOINTS.DONATIONS + "/" + ENDPOINTS.CERTIFICATE, certificateData)
            .then((result) => {
              this.certificateSrc = result.donationCertificate.source;
              this.loadingPreview = false;
            })
            .catch(error => {
              this.previewError = true;
              this.loadingPreview = false;
            });
        }
        this.showSummary = true;
        this.setPayText();
      }
    }
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
  },
  methods: {
    goToPaymentMethodSelection() {
      this.$emit('step', 8);
      this.sms.errorDialog = false;
    },
    getAttributeValueById(id: number): string {
      let attributeValue = this.donation.attributeValues.find(a => a.attributeId === id);
      return attributeValue ? attributeValue.value : "";
    },
    goToSuccessMethodSelection() {
      this.$emit('step', 9);
      this.sms.errorDialog = false;
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.submitting = true;
      this.submitError = false;

      const timeout = setTimeout(() => (this.snackbar = true), 500);

      post(ENDPOINTS.DONATION, this.donation)
        .then(data => {
          // set request and donation from response
          this.$store.commit('updateRequestSession', data.requestSession);
          this.$store.commit('updateDonation', data.donation);
          trackEvent('Payment checkout initiated');

          // Handle redirect if paying with SwedbankPay/Ping/penny
          if (this.isDigitalPayment()) {
            this.$emit('nextStep');
            location.href = data.requestSession.paymentResponse.redirectUrl
          }
          if (this.isInvoicePayment()) {
            // go directly to the invoice step, because it is already 'paid'
            this.$emit('step', 9);
          }
          if (this.isPayLink()) {
            this.loadingSendingSms = true;

            // go directly to the success-view, because it shall be paid later
            // but first we verify that the sms was actually sent
            setTimeout(() => {
              get(ENDPOINTS.SMS + "/" + ENDPOINTS.DONATION + "/" + this.donation.serialnumber + "/" + ENDPOINTS.LATEST + "/" + SmsType.PAY_REQUEST)
                .then((sms: Sms) => {

                  this.loadingSendingSms = false;

                  if (sms.errorMessage && sms.errorMessage.length > 0)
                  {
                    this.sms.errorDialog = true;
                    this.sms.errorMessage = sms.errorMessage;
                  }
                  else
                  {
                    let snackbar: Snackbar = {
                      active: true,
                      color: "success",
                      text: this.$t('payLinkSend.messages.payLinkSend.success'),
                      timeout: 8000,
                      action: null
                    };
                    this.$store.commit('setSnackbar', snackbar);

                    this.$emit('step', 9);
                  }
                }).catch(err => {
                  this.sms.errorDialog = true;
                  this.sms.errorMessage =  this.$t('payLinkSend.messages.payLinkSend.probableErrorCheckPhoneNumber');
              })
            }, this.smsValidationWaitTime)
          }
        }).catch(error => {
          console.log(error);
          this.submitError = true;
          trackEvent('Payment checkout error');
      }).finally(() => {
        clearTimeout(timeout);
        this.submitting = false;
      });
    },
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
    isInvoicePayment() {
      return this.donation && this.donation.paymentSpecification && isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isPayLink() {
      return this.donation && this.donation.paymentSpecification && isPayLink(this.donation.paymentSpecification.paymentMethod.type);
    },
    isDigitalPayment(): boolean {
      return (this.donation && this.donation.paymentSpecification && isDigitalPayment(this.donation.paymentSpecification.paymentMethod.type));
    },
    isDirectPaymentAvailable(): boolean {
      return (this.requestSession.organizationGroup && this.requestSession.organizationGroup.swedbankPaySettings
        && this.requestSession.organizationGroup.swedbankPaySettings.id && this.requestSession.organizationGroup.swedbankPaySettings.id > 0);
    },
    setPayText() {
      if (this.isInvoicePayment()) {
        this.payText = this.$t('confirm.invoice')
      } else if (this.isPayLink()) {
        this.payText = this.$t('confirm.paylink')
      } else {
        this.payText = this.$t('confirm.pay');
      }
    },
  },
});
